import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/get.js";
import _inherits from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import config from "@/lib/config";
import { RESTDataSource } from "@apollo/datasource-rest";
import { v4 as uuidv4 } from "uuid";

var PlaybackEngine = /*#__PURE__*/function (_RESTDataSource) {
  _inherits(PlaybackEngine, _RESTDataSource);

  var _super = _createSuper(PlaybackEngine);

  function PlaybackEngine(options) {
    var _this;

    _classCallCheck(this, PlaybackEngine);

    _this = _super.call(this, options);

    _defineProperty(_assertThisInitialized(_this), "baseURL", config.playback.url);

    _defineProperty(_assertThisInitialized(_this), "merchantId", config.playback.merchantId);

    _this.context = options;
    return _this;
  }

  _createClass(PlaybackEngine, [{
    key: "setPlaybackSessionId",
    value: function setPlaybackSessionId(sessionId) {
      if (this.context.req) {
        this.context.req.playbackSessionId = sessionId;
      }
    }
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(mediaId, sessionId) {
        var _this$context, _this$context$req, _this$context$req$use;

        var params;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  user_id: (_this$context = this.context) === null || _this$context === void 0 ? void 0 : (_this$context$req = _this$context.req) === null || _this$context$req === void 0 ? void 0 : (_this$context$req$use = _this$context$req.userToken) === null || _this$context$req$use === void 0 ? void 0 : _this$context$req$use.id
                };
                this.setPlaybackSessionId(sessionId);
                return _context.abrupt("return", this.get("/session_proxy/open/v1/merchants/".concat(this.merchantId, "/medias/").concat(mediaId), {
                  params: params
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function open(_x, _x2) {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "check",
    value: function () {
      var _check = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(sessionId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setPlaybackSessionId(sessionId);
                return _context2.abrupt("return", this.post("/session/check", {}));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function check(_x3) {
        return _check.apply(this, arguments);
      }

      return check;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(sessionId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setPlaybackSessionId(sessionId);
                return _context3.abrupt("return", this.post("/session_proxy/close", {}));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function close(_x4) {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "willSendRequest",
    value: function willSendRequest(_path, request) {
      var _this$context$req2, _this$context2, _this$context2$req;

      // UAをプロキシする
      request.headers["User-Agent"] = "".concat(this.context.req.deviceInfo.ua, " spooxweb");

      if ((_this$context$req2 = this.context.req) !== null && _this$context$req2 !== void 0 && _this$context$req2.userToken) {
        var _this$context$req$use2 = this.context.req.userToken,
            id = _this$context$req$use2.id,
            accessToken = _this$context$req$use2.accessToken;
        request.headers["X-User-Id"] = id;
        request.headers["Authorization"] = "Bearer ".concat(accessToken);
      }

      if ((_this$context2 = this.context) !== null && _this$context2 !== void 0 && (_this$context2$req = _this$context2.req) !== null && _this$context2$req !== void 0 && _this$context2$req.playbackSessionId) {
        var _this$context3, _this$context3$req;

        request.headers["X-Playback-Session-Id"] = (_this$context3 = this.context) === null || _this$context3 === void 0 ? void 0 : (_this$context3$req = _this$context3.req) === null || _this$context3$req === void 0 ? void 0 : _this$context3$req.playbackSessionId;
      }

      var requestId = uuidv4();
      request.headers["X-Spoox-Web-Playback-Request-Id"] = requestId;
      var userId = request.headers["X-User-Id"];
      console.log("[".concat(requestId, "][Playback][REQUEST INFO] Method: ").concat(request.method, ", Path: ").concat(request.path, ", UserId: ").concat(userId));
    }
  }, {
    key: "didReceiveResponse",
    value: function () {
      var _didReceiveResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(response, request) {
        var requestId;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                requestId = request.headers["X-Spoox-Web-Playback-Request-Id"];
                console.log("[".concat(requestId, "][Playback][RESPONSE INFO] Status: ").concat(response.status));
                return _context4.abrupt("return", _get(_getPrototypeOf(PlaybackEngine.prototype), "didReceiveResponse", this).call(this, response, request));

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function didReceiveResponse(_x5, _x6) {
        return _didReceiveResponse.apply(this, arguments);
      }

      return didReceiveResponse;
    }()
  }]);

  return PlaybackEngine;
}(RESTDataSource);

export default PlaybackEngine;